import store from '../../../store'
window.PLOMB_REMOVER =  new Vue({
    store,
    el: '#plomb_remover',
    name : "SB_PLOMBS_REMOVER",
    data () {
        return {

        }
    },
    created () {
        EventBus.$on('remove_plomb',this.remove_plomb)
    },

    methods : {
        remove_plomb(id) {
            console.log('remove_plomb',id);
            const is_ok = confirm_imc('Виконати ?');
            is_ok.then(res => {
                api.delete('/plombs/' + id).then(({data}) => {
                    if (data.status == "operation_success") {
                        window.location.reload();
                    }
                    this.is_load = false;
                }).catch(err => {
                    this.is_load = false;
                    EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
                });
            });
        },
    },

    components : {

    }
})


